import React from 'react';
import PropTypes from 'prop-types';
import { ContentPackageGridTemplate } from './shared/ContentPackageGridTemplate';

export const ContentPackageTemplate4a = ({
  data,
  content,
  isAboveTheFold = false
}) => {
  return (
    <ContentPackageGridTemplate
      gridConfig={{
        lead: true,
        medium: [1],
        small: [2, 3],
        bottom: 'content_package_bottom'
      }}
      data={data}
      content={content}
      isAboveTheFold={isAboveTheFold}
    />
  );
};

ContentPackageTemplate4a.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
